var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4035 4.27987C11.7947 4.04976 12.2799 4.04976 12.6711 4.27987L18.6341 7.78757C19.0159 8.01215 19.2504 8.42203 19.2504 8.86498V18.9631C19.2504 19.1011 19.1384 19.2131 19.0004 19.2131H14.7871V15.4631C14.7871 13.9443 13.5559 12.7131 12.0371 12.7131C10.5183 12.7131 9.28711 13.9443 9.28711 15.4631V19.2131H5.07422C4.93615 19.2131 4.82422 19.1011 4.82422 18.9631V8.86498C4.82422 8.42203 5.05865 8.01215 5.44044 7.78757L11.4035 4.27987ZM13.4316 2.98697C12.571 2.48073 11.5036 2.48073 10.643 2.98697L4.67991 6.49466C3.83996 6.98876 3.32422 7.89048 3.32422 8.86498V18.9631C3.32422 19.9296 4.10772 20.7131 5.07422 20.7131H19.0004C19.9669 20.7131 20.7504 19.9296 20.7504 18.9631V8.86498C20.7504 7.89048 20.2346 6.98876 19.3947 6.49466L13.4316 2.98697ZM10.7871 15.4631C10.7871 14.7727 11.3468 14.2131 12.0371 14.2131C12.7275 14.2131 13.2871 14.7727 13.2871 15.4631V19.2131H10.7871V15.4631Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/开店系统.66c0152ea62100bb56703cedab3fd2f0.svg";
export { ForwardRef as ReactComponent };